// This is a magic string replaced by rollup

var SDK_VERSION = "8.50.0";
export { SDK_VERSION };